<template>
  <b-tab>
    <template #title>
      <feather-icon icon="KeyIcon" size="16" class="mr-0 mr-sm-50" />
      <span class="d-none d-sm-inline">{{ $t('Wasl') }}</span>
    </template>
    <div>
      <b-tabs>
        <div class="loading_page" v-if="loading">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <b-tab>
          <template #title>
            <feather-icon icon="UserIcon" />
            <span>{{ $t('Wasl Information') }}</span>
          </template>



          <!-- Header: wasl Info -->


          <!-- User Info: Input Fields -->
          <b-form class="mt-2">
            <b-row>

              <!-- Field: identityNumber -->
              <b-col cols="12" md="6">
                <b-form-group :label="$t('Identity Number')" label-for="username">
                  <b-form-input id="identityNumber" v-model="driverData.identityNumber"
                    :state="(errors && ('identityNumber' in errors)) ? false : null" />
                  <small v-if="errors && ('identityNumber' in errors)" class="text-danger">
                    {{ $t(errors['identityNumber'][0]) }}
                  </small>
                </b-form-group>
              </b-col>


              <!-- Field: mobileNumber -->
              <b-col cols="12" md="6">
                <b-form-group :label="$t('Mobile Number')" label-for="mobileNumber">
                  <b-form-input id="mobileNumber" v-model="driverData.mobileNumber"
                    :state="(errors && ('mobileNumber' in errors)) ? false : null" />
                  <small v-if="errors && ('mobileNumber' in errors)" class="text-danger">
                    {{ $t(errors['mobileNumber'][0]) }}
                  </small>
                </b-form-group>
              </b-col>

              <!-- Field: dateOfBirthHijri -->
              <b-col cols="12" md="6" lg="6">
                <b-form-group :label="$t('Date Of Birth Hijri') + ' (e.g 1410-07-01)'" label-for="dateOfBirthHijri">
                  <b-form-input id="dateOfBirthHijri" placeholder="1410-07-01" v-model="driverData.dateOfBirthHijri"
                    :state="(errors && ('dateOfBirthHijri' in errors)) ? false : null"
                    :disabled="$store.state.app_driver.driver.wasl" />
                  <small v-if="errors && ('dateOfBirthHijri' in errors)" class="text-danger">
                    {{ $t(errors['dateOfBirthHijri'][0]) }}
                  </small>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" @click="saveWaslInof('save')"
                variant="primary" class="mr-1">
                {{ $t($store.state.app_driver.driver.wasl ? 'update' : 'register') }}
              </b-button>
              <b-button v-if="$store.state.app_driver.driver.wasl" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button" @click="deleteWasl()" variant="danger" class="mr-1">
                {{ $t('Delete') }}
              </b-button>
            </b-row>

          </b-form>
        </b-tab>

        <b-tab v-if="$store.state.app_driver.driver.wasl" @click="saveWaslInof('getInfo')">
          <template #title>
            <feather-icon icon="InfoIcon" />
            <span>{{ $t('Wasl Status') }}</span>
          </template>
          <div class="mt-5" v-if="Object.keys(waslStatusData).length !== 0">

            <app-timeline>

              <app-timeline-item :title="$t('name')" :subtitle="waslStatusData.name" icon="InfoIcon"
                variant="success" />
              <app-timeline-item :title="$t('company')" :subtitle="waslStatusData.company" icon="InfoIcon"
                variant="success" />
              <app-timeline-item :title="$t('Rgistration Time')" :subtitle="waslStatusData.registrationTime"
                icon="InfoIcon" variant="success" />

              <app-timeline-item :title="$t('Criminal Record Status')" :subtitle="waslStatusData.criminalRecordStatus"
                icon="InfoIcon" variant="success" />
              <app-timeline-item :title="$t('Is Driver Valid')" :subtitle="waslStatusData.isDriverValid.toString()"
                icon="InfoIcon" variant="success" />
              <app-timeline-item :title="$t('Rejection Reasons')" :subtitle="waslStatusData.rejectionReasons"
                icon="InfoIcon" variant="success" />
            </app-timeline>
          </div>
        </b-tab>
      </b-tabs>

    </div>
  </b-tab>

</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BTab, BTabs
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import flatPickr from 'vue-flatpickr-component'

import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref, watch, computed, reactive } from '@vue/composition-api'

import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    flatPickr,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    OrbitSpinner,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BTab,
    BTabs,
    vSelect,
    AppTimeline,
    AppTimelineItem
  },
  directives: {
    Ripple,
  },
  props: {
    driverData: {
      type: Object,
      required: true,
    },

    // errors: {
    //   type: Object,
    //   required: true
    // }

  },

  setup(props, { root }) {

    const errors = ref([])
    const loading = ref(false)
    const waslStatusData = ref({})
    const saveWaslInof = (actionType) => {
      loading.value = true;
      let type = "";
      if (store.state.app_driver.driver.wasl == true) { type = "driverUpdate" }
      if (store.state.app_driver.driver.wasl == false) { type = "driverRegistration" }

      if (actionType == "delete") { type = "driverDelete" }
      if (actionType == "getInfo") { type = "driverInquiry" }
      const waslRegisterRequest = ref({
        "type": type,
        "driver_id": props.driverData.driver_id,
        "identityNumber": props.driverData.identityNumber,
        "mobileNumber": props.driverData.mobileNumber,
        "dateOfBirthHijri": props.driverData.dateOfBirthHijri,
        "activity": "DEFAULT"
      });

      store.dispatch('app_driver/waslDriverSave', waslRegisterRequest.value).
        then(res => {
          //console.log(res)
          loading.value = false;
          errors.value = null;
          if (type !== "driverInquiry") {
            root.$bvToast.toast(
              root.$i18n.t("driver data saved successfully"), {
              title: `Success`,
              variant: 'success',
            })
          } else {
            waslStatusData.value = res
          }


        })
        .catch(reson => {
          if (reson.status == 422) {
            errors.value = reson.data;
            let errorMessage = "Error on save wsal data"
            if (reson.data.errors.errorCode != undefined) {
              errorMessage = reson.data.errors.errorMsg;
            }
            root.$bvToast.toast(
              root.$i18n.t(errorMessage), {
              title: `Error`,
              variant: 'danger',
            })
          }
          //  console.log(reson)
          laodin.value = false;

        }).finally(() => {
          loading.value = false;
        })
    }

    const deleteWasl = id => {

      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("Do you want to delete vehicle from wasl?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          saveWaslInof('delete')

        }
      })
    }
    return {
      avatarText,
      errors,
      saveWaslInof,
      deleteWasl,
      loading,
      waslStatusData
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.custom-timeline,
.d-flex.flex-sm-row.flex-column.flex-wrap.justify-content-between.mb-1.mb-sm-0 h6 {
  font-size: 19px;
  font-style: oblique;
  font-weight: bold;
}
</style>
